import { render, staticRenderFns } from "./price-price-index.vue?vue&type=template&id=4718f802&scoped=true"
import script from "./price-price-index.vue?vue&type=script&lang=js"
export * from "./price-price-index.vue?vue&type=script&lang=js"
import style0 from "./price-price-index.vue?vue&type=style&index=0&id=4718f802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718f802",
  null
  
)

export default component.exports